import { Component } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-platform-businesses-e-tax-invoice',
  templateUrl: './platform-businesses-e-tax-invoice.component.html',
})
export class PlatformBusinessesETaxInvoiceComponent {
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL',
  }
  protected langChangeSubscription: Subscription
  public mockContent: object[]
  constructor(
    private readonly seoService: SEOService,
    private readonly titleService: Title,
    public translate: TranslateService,
  ) {
    this.langChangeSubscription = translate.onLangChange.subscribe((event) => {
      this.setMeta()
    })
  }
  ngOnInit() {
    this.showMockContent()
  }
  setMeta() {
    const metaTitle = this.translate.instant('metaTitle-platform-businesses-e-tax-invoice')
    const metaDescription = this.translate.instant('metaDescription-platform-businesses-e-tax-invoice')
    const imageUrl = 'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/og_image.jpg'

    this.titleService.setTitle(metaTitle)
    this.seoService.createMetaTag(metaTitle, metaDescription)
    this.seoService.createOg(imageUrl, metaTitle, metaDescription)
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
  }
  showMockContent() {
    const lang = this.translate.currentLang
    this.mockContent = [
      {
        link: `https://auth.flowaccount.com/${lang}/Account/Register`,
        alt: 'PLATFORM_BUSINESSES_E_TAX_INVOICE.TAX_INVOICE_BANNER_SHARED.ALT',
        image: `https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/banner/etax_invoice_banner_${lang}.jpg`,
        imageWebp: `https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/banner/etax_invoice_banner_${lang}.webp`,
        imageMobile: `https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/banner/etax_invoice_banner_${lang}_mobile.jpg`,
        imageMobileWebp: `https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/banner/etax_invoice_banner_${lang}_mobile.webp`,
      },
    ]
  }
}
